<style>

.h1-block {
    min-height: 30px;
    cursor: pointer;
}

</style>

<template>

<drag>
    <div class="h1-block align-center justify-center">H1</div>
</drag>

</template>

<script>

import {
    Drag
}
from 'vue-drag-drop';

export default {
    name: 'H1Block',
    components: {
        Drag
    }
}

</script>
